// One full-width box per property on the Status Sheet. Shared by the Pending
// Deals, Active Listings, and Appointments sections — the section decides what
// goes in each slot. Never splits across a printed page (break-inside-avoid).
const PILL = {
  emerald: "bg-emerald-50 text-emerald-800 border-emerald-200",
  sky: "bg-sky-50 text-sky-800 border-sky-200",
  blue: "bg-blue-50 text-blue-800 border-blue-200",
  amber: "bg-amber-50 text-amber-800 border-amber-200",
  slate: "bg-slate-100 text-slate-700 border-slate-200",
};

export default function PropertyCard({ heading, onOpen, pill, meta = [], right, note }) {
  return (
    <div className="border border-slate-200 rounded-lg px-3 py-2 mb-2 break-inside-avoid">
      <div className="flex items-baseline justify-between gap-3">
        {onOpen ? (
          <button
            type="button"
            onClick={onOpen}
            className="text-left text-[13px] font-semibold text-slate-900 hover:underline hover:text-indigo-700 print:no-underline"
          >
            {heading}
          </button>
        ) : (
          <span className="text-[13px] font-semibold text-slate-900">{heading}</span>
        )}
        <div className="flex items-baseline gap-2 shrink-0">
          {right && (
            <span className="text-[13px] font-semibold text-slate-900 tabular-nums">{right}</span>
          )}
          {pill && (
            <span className={`text-[11px] px-2 py-0.5 rounded-full border ${PILL[pill.tint] || PILL.slate}`}>
              {pill.label}
            </span>
          )}
        </div>
      </div>
      {(meta.length > 0 || note) && (
        <div className="flex flex-wrap items-baseline gap-x-4 gap-y-0.5 mt-1 text-[12px] text-slate-600">
          {meta.filter(Boolean).map((m, i) => (
            <span key={i}>{m}</span>
          ))}
          {note && <span className="flex-1 min-w-[140px]">{note}</span>}
        </div>
      )}
    </div>
  );
}
